import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class OrderTrackingActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("./OrderTracking")
	}

	render() {
		return ( 
			<Activity 
				name="orderTracking"
				RenderedComponent={this.RenderedComponent}
				context="AccountingManualJournalEntries"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(OrderTrackingActivity)